import React from 'react';
import PropTypes from 'prop-types';
import {
    TimeLineWrapper,
    TimeLineContent,
    TimeLineItem,
    Title,
    Description,
    Right,
} from './index.styles';

export const TimeLine = ({ events, orientation, startFrom, titleBold, descriptionBold }) => {
    if (startFrom === 'last') {
        events.reverse();
    }

    const eventsMappedToElements = events.map(e => (
        <TimeLineItem key={e.time}>
            <TimeLineContent>
                <Right />
                <Title titleBold={titleBold}>{e.title}</Title>
                <Description descriptionBold={descriptionBold}>{e.desc}</Description>
            </TimeLineContent>
        </TimeLineItem>
    ));

    return <TimeLineWrapper orientation={orientation}>{eventsMappedToElements}</TimeLineWrapper>;
};

TimeLine.propTypes = {
    events: PropTypes.arrayOf(
        PropTypes.shape({
            time: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired,
            desc: PropTypes.string.isRequired,
        }),
    ).isRequired,
    orientation: PropTypes.oneOf(['horizontal', 'vertical']),
    startFrom: PropTypes.oneOf(['first', 'last']),
    titleBold: PropTypes.bool,
    descriptionBold: PropTypes.bool,
};

TimeLine.defaultProps = {
    orientation: 'vertical',
    startFrom: 'last',
    titleBold: true,
    descriptionBold: false,
};
